<template>
  <div class="baseContentRight">
    <div class="baseContentTitle">
      <span href="#" v-for="(item,index) in navigationList" :key="index">
        {{langes==0?(item.barName?item.barName:item['aboutTitle']):(item.barEngName?item.barEngName:item['aboutTitle'+'En'])}}
        <span v-if="index!=navigationList.length-1">></span>
      </span>
    </div>
    <div class="baseContentContent">
      <p v-if="langes==0" v-html="currentObj['aboutContent']"></p>
      <p v-else v-html="currentObj['aboutContent'+'En']"></p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    currentObj: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      navigationList: [],
      langes:0
    }
  },
  watch: {
    currentObj: {
      deep: true,
      handler: function () {
        this.navigationList = JSON.parse(sessionStorage.getItem('pathList'))
      }
    }
  },
  inject: ['parentEle'],
  mounted(){
    this.langes = sessionStorage.getItem('watchStorage');
     window.addEventListener('setItem', () => {
      this.langes = sessionStorage.getItem('watchStorage');
    })
  }
}
</script>
<style scoped lang="less">
.baseContentRight {
  width: calc(~"100% - 253px");
  float: right;
  .baseContentTitle {
    height: 27px;
    padding-top: 6px;
    background: url("http://www.worldelite.net.cn/data/templates/cn/img/title_bg.jpg") repeat-x;
    line-height: 27px;
    padding-left: 12px;
    color: #747575;
    text-align: left;
    & > span {
      color: #747575;
      cursor: pointer;
    }
    & > span:last-child {
      cursor: initial;
    }
  }
  .baseContentContent {
    padding-top: 12px;
    padding-bottom: 12px;
    color: #706f6f;
    line-height: 1.8;
    p {
      text-align: left;
    }
  }
}
</style>